export default "__VITE_ASSET__PaKKUKMH__"